import feHelper from 'features/FE/feHelper';
import { AppDialogHelper } from 'general/components/AppDialog';
import KTBSButton, {
  KTBSButtonColor,
  KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import useScrollToTop from 'hooks/useScrollToTop';
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';

ChargePaymentQRScreen.propTypes = {};

function ChargePaymentQRScreen(props) {
  // ---- params ----
  const { t } = useTranslation();
  const router = useRouter();
  const serialNumber = router.query?.serialNumber;
  const currentPath = router.location?.pathname || '';
  const { qrData, payment, expiryInSeconds } = useSelector((state) => state.fe);
  const { bankList } = useSelector((state) => state.app);
  const [currentBank, setCurrentBank] = useState({});
  useEffect(() => {
    const bin = qrData?.bin;
    if (!_.isUndefined(bin) && !_.isEmpty(bankList)) {
      const bankItem = _.find(bankList, (i) => i.bin === bin);
      setCurrentBank(bankItem);
    }
  }, [qrData, bankList]);
  const refTimerApi = useRef();
  const [showTimer, setShowTimer] = useState(false);
  useEffect(() => {
    setShowTimer(expiryInSeconds > 0);
  }, [expiryInSeconds]);
  const [remainTimeText, setRemainTimeText] = useState(Utils.convertSecondsToMS(expiryInSeconds));
  const refRemainTime = useRef(expiryInSeconds);
  const refBottom = useRef();

  useScrollToTop();

  useEffect(() => {
    getChargePaymentStatus();
    const timerApi = setInterval(() => {
      getChargePaymentStatus();
    }, AppConfigs.timeIntervalGetChargePaymentStatus);
    refTimerApi.current = timerApi;

    return () => {
      if (timerApi) clearInterval(timerApi);
    };
  }, []);

  useEffect(() => {
    var timerClock;
    timerClock = setInterval(() => {
      refRemainTime.current -= 1;
      const str =
        refRemainTime.current > 0 ? Utils.convertSecondsToMS(refRemainTime.current) : '00:00';
      setRemainTimeText(str);
    }, 1000);

    return () => {
      if (timerClock) clearInterval(timerClock);
    };
  }, []);

  // ---- methods ----
  const getChargePaymentStatus = () => {
    const params = {
      paymentId: payment?.paymentId,
      transactionId: payment?.transactionId,
    };
    console.log({ params });
    feHelper.callApiCheckPaymentStatus(params).then((data) => {
      let status = data;
      if (status === 'COMPLETED') {
        if (refTimerApi?.current) {
          clearInterval(refTimerApi.current);
          refTimerApi.current = null;
        }
        setShowTimer(false);
        // chuyen sang man hinh chi tiet phien sac
        // router.navigate('/prepaid/qr/transaction-detail');
        // hien thi thong bao da thanh toan thanh cong
        if (currentPath.includes('prepaid/qr')) {
          AppDialogHelper.show(
            'Thanh toán thành công',
            'Cảm ơn quý khách đã hoàn tất giao dịch. Nhấn bắt đầu để tiến hành phiên sạc.',
            [
              {
                title: (
                  <span style={{ fontSize: Utils.convertToFontSize(18) }}>{t('startCharge')}</span>
                ),
                type: 'positive',
                onClick: () => {
                  AppDialogHelper.hide();
                  // chuyen sang man hinh chi tiet phien sac
                  router.navigate(`/prepaid/qr/transaction/${payment?.transactionId}`);
                },
              },
            ],
            true,
            AppResource.images.dialogIcons.dialogSuccess,
            <></>,
            'sm'
          );
        } else if (currentPath.includes('topup')) {
          AppDialogHelper.show(
            'Thanh toán thành công',
            'Quý khách đã nạp tiền thành công. Vui lòng chạm thẻ RFID vào khu vực quét thẻ để mở khóa vòi sạc và bắt đầu sạc xe.',
            [
              {
                title: (
                  <span style={{ fontSize: Utils.convertToFontSize(18) }}>Tôi đã hiểu</span>
                ),
                type: 'neutral',
                onClick: () => {
                  AppDialogHelper.hide();
                  router.navigate(`/topup/${serialNumber}`);
                },
              },
            ],
            true,
            AppResource.images.dialogIcons.dialogTopUpSuccess,
            <></>,
            'sm'
          );
        }
      } else if (status === 'FAILED' || !Utils.isValid(status)) {
        if (refTimerApi?.current) {
          clearInterval(refTimerApi.current);
          refTimerApi.current = null;
        }
        setShowTimer(false);
        setRemainTimeText('00:00');
        if (currentPath.includes('prepaid/qr')) {
          AppDialogHelper.show(
            'Thanh toán thất bại',
            'Rất tiếc, giao dịch của quý khách chưa thành công. Xin vui lòng thử lại.',
            [
              {
                title: <span style={{ fontSize: Utils.convertToFontSize(18) }}>{t('close')}</span>,
                type: 'neutral',
                onClick: () => {
                  AppDialogHelper.hide();
                  router.navigate(-1);
                },
              },
            ],
            true,
            AppResource.images.dialogIcons.dialogError,
            <></>,
            'sm'
          );
        } else if (currentPath.includes('topup')) {
          AppDialogHelper.show(
            'Thanh toán thất bại',
            'Rất tiếc, giao dịch của quý khách chưa thành công. Xin vui lòng thử lại.',
            [
              {
                title: (
                  <span style={{ fontSize: Utils.convertToFontSize(18) }}>Về trang chủ</span>
                ),
                type: 'neutral',
                onClick: () => {
                  AppDialogHelper.hide();
                  router.navigate(`/topup/${serialNumber}`);
                },
              },
              {
                title: (
                  <span style={{ fontSize: Utils.convertToFontSize(18) }}>Thử lại</span>
                ),
                type: 'negative',
                onClick: () => {
                  AppDialogHelper.hide();
                  router.navigate(`/topup/${serialNumber}`);
                },
              },
            ],
            true,
            AppResource.images.dialogIcons.dialogTopUpFailed,
            <></>,
            'sm'
          );
        }
      }
    });
  };

  const buildRowItem = (name, value, valueColor = AppColors.gray[800]) => {
    return (
      <div className="d-flex justify-content-between px-4">
        <span>{name}</span>
        <span
          style={{
            color: valueColor,
            fontWeight: '600',
            fontSize: Utils.convertToFontSize(16),
          }}
        >
          {value}
        </span>
      </div>
    );
  };

  const buildRowItem2 = (
    name,
    value,
    valueColor = AppColors.gray[800],
    showButton = true,
    icon
  ) => {
    return (
      <div className="d-flex justify-content-between align-items-center px-4">
        <div className="d-flex">
          {icon && <img className="h-40px" src={icon} />}
          <div className="d-flex flex-column">
            <span style={{ color: AppColors.gray[600] }}>{name}</span>
            <span
              style={{
                color: valueColor,
                fontWeight: '600',
                fontSize: Utils.convertToFontSize(16),
              }}
            >
              {value}
            </span>
          </div>
        </div>

        {/* sao chep */}
        {showButton && (
          <div className="ml-4">
            <KTBSButton
              color={KTBSButtonColor.secondary}
              title={t('copy')}
              size={KTBSButtonSize.small}
              borderRadius={5}
              buttonTitleFontWeight="700"
              onPress={() => {
                Utils.copyTextToClipboard(value, () => {
                  ToastHelper.showSuccess(t('copied'));
                });
              }}
              buttonTitleColor={'rgba(74, 86, 119, 1)'}
            />
          </div>
        )}
      </div>
    );
  };

  const buildSeparator = () => {
    return (
      <div
        className="my-4"
        style={{
          borderBottom: `1px dashed ${AppColors.gray[300]}`,
        }}
      ></div>
    );
  };

  const handleDownloadQr = () => {
    const svg = document.getElementById('payment-qr-canvas');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');

      const downloadLink = document.createElement('a');
      downloadLink.download = 'qrcode';
      downloadLink.href = `${pngFile}`;
      downloadLink.click();
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center justify-content-center py-5"
      style={{
        backgroundImage: `url(${AppResource.images.evg.bgAuthForm})`,
        backgroundSize: 'cover',
      }}
    >
      <div
        className="container"
        style={{
          paddingBottom: `${refBottom.current?.offsetHeight}px`,
        }}
      >
        {/* header */}
        <div className="d-flex flex-column align-items-center px-5 py-10">
          <div className="d-flex flex-column align-items-center">
            <img alt="logo" src={AppResource.icons.evg.evgLogoAuth} className="w-175px" />
          </div>
        </div>

        <div
          className="p-5 bg-white"
          style={{
            border: `1px solid ${AppColors.gray[300]}`,
            borderRadius: '10px',
          }}
        >
          <span
            style={{
              fontWeight: '600',
              fontSize: Utils.convertToFontSize(18),
              color: AppColors.gray[800],
            }}
          >
            {t('paymentInfo')}
          </span>

          <div
            className="pt-4 mt-2 px-0 d-flex flex-column align-items-center"
            style={{
              border: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '5px',
            }}
          >
            {/* <img
              src={AppResource.images.dialogIcons.dialogActiveCharge}
              className="w-180px h-180px"
            /> */}
            <div
              style={{
                height: '180px',
                margin: '0 auto',
                width: '180px',
                border: `1px solid ${AppColors.primary}`,
                borderRadius: '5px',
              }}
              className="p-2 mb-2"
            >
              <QRCode
                id="payment-qr-canvas"
                size={256}
                style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                value={qrData}
                viewBox={`0 0 256 256`}
              />
            </div>

            {/* <img className="h-40px mb-2" src={currentBank?.logo} /> */}
            {showTimer && (
              <div className="d-flex flex-column align-items-center">
                <span
                  style={{
                    color: AppColors.gray[900],
                    fontWeight: '700',
                    fontSize: Utils.convertToFontSize(16),
                  }}
                >
                  {t('remainingTime')}
                </span>
                <span
                  style={{
                    color: AppColors.danger,
                    fontWeight: '700',
                    fontSize: Utils.convertToFontSize(24),
                  }}
                >
                  {remainTimeText}
                </span>
              </div>
            )}

            {/* tai anh ve */}
            <div
              className="w-100 p-4 mt-2"
              style={{
                borderTop: `1px solid ${AppColors.gray[300]}`,
              }}
            >
              <KTBSButton
                color={KTBSButtonColor.secondary}
                title={t('downloadImage')}
                size={KTBSButtonSize.large}
                borderRadius={5}
                buttonTitleFontWeight="600"
                onPress={handleDownloadQr}
                additionalClassName="w-100"
                buttonTitleColor={'#4A5677'}
                buttonTitleFontSize={18}
              />
            </div>
          </div>

          {/* huong dan thanh toan */}
          <div
            className="p-5 d-flex align-items-start mt-4"
            style={{
              backgroundColor: 'rgba(247, 255, 246, 1)',
              border: `1px dashed ${AppColors.primary}`,
            }}
          >
            <div
              className="rounded-circle d-flex align-items-center justify-content-center p-3 w-35px"
              style={{
                aspectRatio: '1/1',
                backgroundColor: 'rgb(204, 241, 219)',
              }}
            >
              <i className="fa-regular fa-lightbulb-on" style={{ color: AppColors.primary }} />
            </div>

            <div className="d-flex flex-column ml-4">
              <span
                style={{
                  color: AppColors.primary,
                  fontWeight: '700',
                  fontSize: Utils.convertToFontSize(20),
                }}
              >
                Hướng dẫn thanh toán
              </span>
              <span
                style={{
                  color: AppColors.gray[700],
                  fontWeight: '600',
                  fontSize: Utils.convertToFontSize(16),
                }}
              >
                Mở App ngân hàng bất kỳ để{' '}
                <span style={{ color: AppColors.primary }}>quét mã QR</span>
              </span>
            </div>
          </div>

          {/* trang thai */}
          <div
            className="py-4 mt-3 font-weight-bold"
            style={{
              border: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '5px',
              fontSize: Utils.convertToFontSize(16),
              color: AppColors.gray[600],
            }}
          >
            {buildRowItem(t('status'), feHelper.getWalletTransactionStatusName(payment?.status), feHelper.getWalletTransactionStatusColor(payment?.status))}
          </div>

          {/* thong tin chuyen khoan */}
          {/* <div
            className="py-4 mt-3 d-flex flex-column font-weight-bolder"
            style={{
              border: `1px solid ${AppColors.gray[300]}`,
              borderRadius: '5px',
              fontSize: Utils.convertToFontSize(16),
            }}
          >
            {buildRowItem2(
              t('bank'),
              currentBank?.name,
              AppColors.gray[600],
              false,
              currentBank?.logo
            )}
            {buildSeparator()}
            {buildRowItem2(t('accountName'), qrData?.accountName, AppColors.gray[800], false)}
            {buildSeparator()}
            {buildRowItem2(t('accountNumber'), qrData?.accountNumber)}
            {buildSeparator()}
            {buildRowItem2(
              t('amount'),
              Utils.formatNumber(qrData?.amount) + ' ' + qrData?.currency
            )}
            {buildSeparator()}
            {buildRowItem2(t('content'), qrData?.description)}
          </div> */}

          {/* luu y */}
          {/* <div className="mt-4">
            <span
              style={{
                color: AppColors.gray[700],
                fontWeight: '500',
                fontSize: Utils.convertToFontSize(14),
              }}
            >
              <span style={{ fontWeight: '700' }}>Lưu ý:</span> nhập chính xác số tiền{' '}
              <span style={{ color: AppColors.primary, fontWeight: '700' }}>
                {Utils.formatNumber(qrData?.amount)}
              </span>
              , nội dung{' '}
              <span style={{ color: AppColors.primary, fontWeight: '700' }}>
                {qrData?.description}
              </span>{' '}
              khi chuyển khoản{' '}
            </span>
          </div> */}

          {/* huy bo */}
          <div className="mt-4">
            <KTBSButton
              color={KTBSButtonColor.secondary}
              title={t('cancel')}
              buttonTitleFontSize={18}
              borderRadius={5}
              buttonTitleFontWeight="600"
              onPress={() => {
                router.navigate(-1);
              }}
              additionalClassName="w-100"
              buttonTitleColor={'rgba(74, 86, 119, 1)'}
            />
          </div>
        </div>
      </div>
      {/* <div className="mt-4 position-fixed bottom-0 mx-0 vw-100" ref={refBottom}>
        <div
          className="p-5 bg-white w-100"
          style={{
            border: `1px solid ${AppColors.gray[300]}`,
            borderBottom: '0px',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
          }}
        >
          <KTBSButton
            color={KTBSButtonColor.secondary}
            title={t('cancel')}
            buttonTitleFontSize={18}
            borderRadius={5}
            buttonTitleFontWeight="600"
            onPress={() => {
              router.navigate(-1);
            }}
            additionalClassName="w-100"
            buttonTitleColor={'rgba(74, 86, 119, 1)'}
          />
        </div>
      </div> */}
    </div>
  );
}

export default ChargePaymentQRScreen;
